// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"75778718","821":"5ce1abec"}[chunkId] + ".chunk.js";
};